import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Footer actions for the letter composer: preview toggle, cancel, and send. */
export function LetterComposerFooter(_ref) {
  var composerId = _ref.composerId,
    hasContent = _ref.hasContent,
    isPreview = _ref.isPreview,
    isSaving = _ref.isSaving,
    canSend = _ref.canSend,
    onTogglePreview = _ref.onTogglePreview,
    onCancel = _ref.onCancel,
    onSend = _ref.onSend;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center justify-between gap-3"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    "data-testid": "letter-preview-toggle",
    disabled: !hasContent,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LETTER_PREVIEW_TOGGLE, {
        composerId: composerId
      });
      onTogglePreview();
    }
  }, isPreview ? t("edit", {
    defaultValue: "Edit"
  }) : t("preview", {
    defaultValue: "Preview"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    "data-testid": "composer-cancel-".concat(composerId),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.COMPOSER_CANCEL, {
        composerId: composerId
      });
      onCancel();
    }
  }, t("cancel", {
    defaultValue: "Cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "composer-save-".concat(composerId),
    loading: isSaving,
    disabled: !canSend,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.COMPOSER_SAVE, {
        composerId: composerId
      });
      onSend();
    }
  }, t("send_letter", {
    defaultValue: "Send letter"
  }))));
}